var orase = {
    brasov:['https://www.youtube.com/watch?v=nLaDW4Ok7NM','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg','9.jpg','10.jpg'],
    alba:['https://www.youtube.com/watch?v=dyywPOTuS1I','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg','9.jpg','10.jpg'],
    bistrita:['https://www.youtube.com/watch?v=_5P8se5ltNo','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg','9.jpg','10.jpg','11.jpg'],
    sibiu:['https://www.youtube.com/watch?v=qiXjXBfqO-s','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg','9.jpg','10.jpg','11.jpg','12.jpg','13.jpg'],
    cluj:['https://www.youtube.com/watch?v=lzn_GmaDhgY','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg','9.jpg','10.jpg'],
    baiamare:['https://www.youtube.com/watch?v=HUmvq182058','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg','9.jpg','10.jpg'],
    oradea:['https://www.youtube.com/watch?v=tVIxKBhTuYE','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg','9.jpg','10.jpg'],
    timisoara:['https://www.youtube.com/watch?v=zRtAPr0GoEQ','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg','9.jpg','10.jpg'],
    arad:['https://www.youtube.com/watch?v=3wEC1HrMJLg','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg','9.jpg','10.jpg','11.jpg'],
    targujiu:['https://www.youtube.com/watch?v=qWYhlGtOuW0','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg','9.jpg','10.jpg','11.jpg','12.jpg','13.jpg'],
    craiova:['https://www.youtube.com/watch?v=fEkFYbUev2I','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg','9.jpg','10.jpg','11.jpg','12.jpg','13.jpg','14.jpg'],
    pitesti:['https://www.youtube.com/watch?v=P8Q3hDHHIiA','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg','9.jpg','10.jpg','11.jpg','12.jpg','13.jpg'],
	buzau:['https://www.youtube.com/watch?v=P4E11CgXtc0','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg','9.jpg','10.jpg','11.jpg'],
	iasi:['https://www.youtube.com/watch?v=-6bzobnRumA','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg','9.jpg','10.jpg','11.jpg','12.jpg','13.jpg','14.jpg','15.jpg','16.jpg'],
	suceava:['https://www.youtube.com/watch?v=txTva119Kdw','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg','9.jpg','10.jpg','11.jpg','12.jpg','13.jpg','14.jpg','15.jpg','16.jpg'],
	focsani:['https://www.youtube.com/watch?v=VeNkJ3ArOYA','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg','9.jpg','10.jpg','11.jpg','12.jpg','13.jpg'],
	bacau:['https://www.youtube.com/watch?v=crEzuF90IhM','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg','9.jpg','10.jpg','11.jpg','12.jpg','13.jpg','14.jpg','15.jpg','16.jpg','17.jpg','18.jpg','19.jpg','20.jpg','21.jpg','22.jpg','23.jpg','24.jpg','25.jpg']
}
var dates = ['2018-06-15','2018-06-17','2018-06-19','2018-06-21','2018-06-24','2018-06-26','2018-06-28','2018-06-30','2018-07-03','2018-07-05','2018-07-08','2018-07-10','2018-07-12','2018-07-15','2018-07-17','2018-07-19','2018-07-22'],
	now = new Date().toISOString();
	//console.log(now);

$(document).ready(function() {

    var count = $('.cities .item').length - 1;

    for (var oras in orase) {
        $('*[data-target="'+oras+'"]').addClass('gallery');
    }

    $('.cities .item').each(function(index){
        //console.log(now +' - '+ dates[index]);
        if (now >= dates[index]+'T23:59:59Z') {
            $(this).addClass('passed');
            $('#oras-'+index).attr('class','passed');
        }

        if ( count == index ) {
            $('.item.passed').last().next().addClass('active');
            if ($('.item.active .iconfont-camera').length) {
                $('.item.active .iconfont-camera').addClass('iconfont-truck').removeClass('iconfont-camera');
            } else {
                $('.item.active').prepend('<span class="iconfont-truck"></span>');
            }
            $('#oras-'+$('.item.active').index()).attr('class','active');
        }

    });

    $(".inpage").on('click', function(event) {
        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "") {
          event.preventDefault();
          scrollToSection(this.hash, 47, this.hash);
        }
      });

    $('.cities').slick({
        infinite:false,
        arrows:true,
		prevArrow: '<button type="button" class="slick-prev iconfont-left-arrow"></button>',
		nextArrow: '<button type="button" class="slick-next iconfont-right-arrow"></button>',
        dots:true,
        swipe: false,
        //centerMode: true,
        initialSlide: 16,
        slidesToShow: 5,
        slidesToScroll: 5,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
				//initialSlide: $('.item.active').index()-1,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                swipe: true,
				 //initialSlide: $('.item.active').index()
              }
            }
          ]
    });

    $('.ce-aduce').slick({
        infinite:true,
        arrows:false,
        dots:true,
        fade: true,
        autoplay: 5000
    });

    //scroll animations
    var controller = new ScrollMagic.Controller();

    var scene = new ScrollMagic.Scene({
            triggerElement: ".section2-img-1", duration: 0, offset: 0
        })
        .setTween(
            new TimelineMax()
            .fromTo(".traseu1", 0.25, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
            .fromTo(".traseu2", 0.25, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
        )
        .addTo(controller);

    var scene = new ScrollMagic.Scene({
            triggerElement: ".section2-img-2", duration: 0, offset: 0
        })
        .setTween(
            new TimelineMax()
            .fromTo(".traseu3", 0.25, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
            .fromTo(".traseu4", 0.25, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
            .fromTo(".traseu5", 0.25, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
            .fromTo(".traseu6", 0.25, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
        )
        .addTo(controller);

    var scene = new ScrollMagic.Scene({
            triggerElement: ".section2-img-3", duration: 0, offset: 0
        })
        .setTween(
            new TimelineMax()
            .fromTo(".traseu7", 0.25, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
            .fromTo(".traseu8", 0.25, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
            .fromTo(".traseu9", 0.25, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
            .fromTo(".traseu10", 0.25, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
        )
        .addTo(controller);

    var scene = new ScrollMagic.Scene({
            triggerElement: "#harta", duration: 0, offset: 0, reverse: false
        })
        .setTween(
            new TimelineMax()
            .fromTo("#outline", 0.25, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
            .fromTo("#slice1", 0.25, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
            .fromTo("#slice2a, #slice2b", 0.25, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
            .fromTo("#slice3a, #slice3b", 0.25, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
            .fromTo("#slice4a, #slice4b", 0.25, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
            .fromTo("#slice5a, #slice5b", 0.25, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
            .fromTo("#slice6", 0.25, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
            .fromTo("#judete, #orase", 0.25, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
            .fromTo(".section4-left", 0.3, {opacity: 0, x:'-100%'}, {opacity:1, x:'0%', ease: Power2.easeOut})
            .fromTo(".section4-right", 0.3, {opacity: 0, x:'100%'}, {opacity:1, x:'0%', ease: Power2.easeOut}, '-=0.3')
            //.fromTo("#orase", 0.25, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
        )
        .addTo(controller);

    var $lg = $('#gallery');
    $('.gallery').click(function(){
        var oras = $(this).data('target'),
            images = orase[oras];
        $('#gallery').html('');

        for (var i = 0; i  < images.length; i++)  {
            if (images[i].match('youtube')) {
                var match = images[i].match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/);
                $('#gallery').append('<a href="'+images[i]+'" data-poster=//img.youtube.com/vi/'+match[7]+'/maxresdefault.jpg"></a>');
            } else {
                $('#gallery').append('<a href="/assets/gallery/caravana-2018/'+oras+'/'+images[i]+'"></a>');
            }
        }

        $lg.lightGallery({
            mode: 'lg-fade',
            autoplayControls: false,
            thumbnail: false,
            download: false,
            autoplay: false,
            share: false,
            zoom: false,
            youtubePlayerParams: {
                showinfo: 0,
                rel: 0
            }
        }).find('a').first().trigger('click');

    });

    $lg.on('onCloseAfter.lg', function(){
        $lg.data('lightGallery').destroy(true);
    });

});
